export const getScrollToTopState = (state) => state.scrollToTop.scroll;
